var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserType1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#5C5B69",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 16c-6.729 0-12 2.855-12 6.5S9.271 29 16 29s12-2.855 12-6.5S22.729 16 16 16zm0 11c-5.894 0-10-2.372-10-4.5S10.106 18 16 18s10 2.372 10 4.5S21.894 27 16 27zm0-13c3.032 0 5.5-2.467 5.5-5.5S19.032 3 16 3s-5.5 2.467-5.5 5.5S12.968 14 16 14zm0-9c1.93 0 3.5 1.57 3.5 3.5S17.93 12 16 12s-3.5-1.57-3.5-3.5S14.07 5 16 5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserType1);
export default __webpack_public_path__ + "static/media/user-type-1.7a64adf3987e4b3d9976f54c9ee22348.svg";
export { ForwardRef as ReactComponent };